import { tokens } from '@fluentui/react-components';

export const NOTIFY_VARIANTS = {
  success: {
    timeoutMs: 5000,
    progressColor: 'success',
    backgroundColor: tokens.colorStatusSuccessBackground1,
    borderColor: tokens.colorStatusSuccessBorder1,
  },
  error: {
    timeoutMs: 20000,
    progressColor: 'error',
    backgroundColor: tokens.colorStatusDangerBackground1,
    borderColor: tokens.colorStatusDangerBorder1,
  },
  warning: {
    timeoutMs: 15000,
    progressColor: 'warning',
    backgroundColor: tokens.colorStatusWarningBackground1,
    borderColor: tokens.colorStatusWarningBorder1,
  },
  info: {
    timeoutMs: 8000,
    progressColor: 'brand',
    backgroundColor: tokens.colorNeutralBackground3,
    borderColor: tokens.colorNeutralStroke1,
  },
} as const;

export type NotifyVariant = keyof typeof NOTIFY_VARIANTS;

export type NotifyShowOptions = {
  timeoutMs?: number | null;
  action?: {
    label: string;
    onClick: () => void;
  };
};
